var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBlueSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54beff",
    d: "M 149.566406 166.097656 L 138.871094 166.097656 C 135.925781 166.097656 133.519531 168.507812 133.519531 171.449219 L 133.519531 182.144531 C 133.519531 185.085938 135.925781 187.496094 138.871094 187.496094 L 149.566406 187.496094 C 152.507812 187.496094 154.917969 185.085938 154.917969 182.144531 L 154.917969 171.449219 C 154.917969 168.507812 152.507812 166.097656 149.566406 166.097656 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlueSquare);
export default __webpack_public_path__ + "static/media/SmallBlueSquare.c49feba257859eb00160860b54fbc27d.svg";
export { ForwardRef as ReactComponent };